import React, { Component } from 'react';
import {DesignedButton } from '../../../FaqPage/CustomizedProduction/DesignedButton/DesignedButton';
import i18n from '../../../i18n';
import './emptyVideo.scss';
class emptyVideo extends Component {
    render() {
        const {onViewAllFreeVideosButtonClicked, isNew } = this.props;
        return (
        <div className={isNew ? 'btnarea' : 'btnarea-wide'}>
            <div className="emptyVideo">
                    {/* <img className="emptyImg" src={ this.props.img} alt=""></img> */}
                <div>
                    {this.props.text1}<br></br>
                    {this.props.text2}
                </div>
                {this.props.btn ? 
                <DesignedButton left={this.props.left} img="https://front.videomonster.com/images-u6yd72dy/web/arrow_w.svg" color={"black"} text={this.props.btntext ? this.props.btntext : i18n.t("likedvideo.button.text")} margin ={"20px auto"} onClick={onViewAllFreeVideosButtonClicked}/>
                : ("")
                }
                
            </div>
        </div>
         
        );
    }
}

export default emptyVideo;